<div class="d-flex justify-content-between">
  <p class="text--big mb-0 pt-1" [translate]="label" [translateParams]="translateParams"></p>
  <div class="switch r flex-shrink-0">
    <input type="checkbox" class="checkbox" (change)="toggleChanged.emit($event.target.checked)" [checked]="isToggled" />
    <div class="knobs"></div>
    <div class="layer"></div>
  </div>
</div>
